// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"parentheses"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.1084 5C3.07812 7.11438 2.5 9.48969 2.5 12C2.5 14.5103 3.07812 16.8856 4.1084 19M19.8916 19C20.9219 16.8856 21.5 14.5103 21.5 12C21.5 9.48969 20.9219 7.11438 19.8916 5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ParenthesesIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'parentheses',
    ref,
    icon: element,
  },
));

ParenthesesIcon.displayName = 'ParenthesesIcon';

export default ParenthesesIcon;
